var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 9.5,
    r: 6.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 9.5,
    r: 6.125,
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4291 1.5713C14.2779 1.41817 14.0979 1.29659 13.8993 1.21361C13.7008 1.13062 13.4878 1.08789 13.2726 1.08789C13.0575 1.08789 12.8444 1.13062 12.6459 1.21361C12.4474 1.29659 12.2673 1.41817 12.1162 1.5713L11.0762 2.62755L13.3728 4.92422L14.4128 3.88422C14.567 3.73414 14.6899 3.55493 14.7743 3.35699C14.8586 3.15905 14.9029 2.94632 14.9044 2.73115C14.9059 2.51599 14.8647 2.30266 14.7831 2.10355C14.7015 1.90445 14.5812 1.72353 14.4291 1.5713Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3068 3.39673L5.76217 7.94131C5.72143 7.9832 5.68679 8.03061 5.65926 8.08214L4.15342 11.1209C4.10974 11.2029 4.08789 11.2948 4.08998 11.3877C4.09207 11.4806 4.11803 11.5714 4.16536 11.6514C4.2127 11.7314 4.27981 11.7978 4.36025 11.8444C4.44069 11.8909 4.53175 11.916 4.62467 11.9171C4.70721 11.9175 4.78873 11.899 4.86301 11.863L7.90176 10.3571C7.9533 10.3296 8.0007 10.295 8.04259 10.2542L12.5872 5.70965L10.3068 3.39673Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignTask);
export default __webpack_public_path__ + "static/media/assignTask.56a8d025d79c93d1fa9192e732c0e1d3.svg";
export { ForwardRef as ReactComponent };